/**
 * 实名认证域 API(W-2)。端点:
 *   POST /api/v1/auth/kyc/verify { name,idCardNo,phone,bankCard } → TokenPairResponse
 * verify 成功返回**重签发**的 token 对(identityState=KYC_VERIFIED),前端须写会话 store。
 * 四要素核验为后端 mock provider,身份态机迁移与落库真实生效(UI 不标 mock)。
 * 证件 OCR 已移除(ADR-0024 D2:真 OCR 延后到 Growth,mock 无价值)。
 */
import { call } from './client';
import type { components } from './openapi.generated';

type Schemas = components['schemas'];
export type KycVerifyRequest = Schemas['KycVerifyRequest'];
export type TokenPairResponse = Schemas['TokenPairResponse'];

/** 四要素不一致(留屏可重试)。 */
export const CODE_KYC_FOUR_ELEMENT_FAILED = '010404';
/** 当日核验超 3 次(禁用提交)。 */
export const CODE_KYC_RATE_EXCEEDED = '010405';

export function verifyKyc(req: KycVerifyRequest): Promise<TokenPairResponse> {
  return call<TokenPairResponse>({
    method: 'POST',
    url: '/api/v1/auth/kyc/verify',
    data: req,
  });
}
